/*
 * Browsers cache a failed dynamic import per specifier for the page's lifetime,
 * so re-running the same import() can never recover. The retry-dynamic-imports
 * plugin in vite.config.js rewrites built dynamic imports to call this instead;
 * the cache-busting query makes the retry a new specifier, forcing a real fetch.
 */
export function installRetryChunkImport(): void {
    globalThis.__retryChunkImport = async (specifier, importer) => {
        const url = new URL(specifier, importer).href;
        try {
            return await import(/* @vite-ignore */ url);
        } catch {
            const busted = new URL(url);
            busted.searchParams.set("t", Date.now().toString());
            console.log("retrying with cache busting", busted.href);
            return await import(/* @vite-ignore */ busted.href);
        }
    };
}
